import constructLocalEntity from 'src/utils/vuexModuleConstructor/constructLocalEntity';
import { hideWhenCreatingAndEditing } from 'src/types/columnFlags';
import localEntityListInMenuItem from 'src/utils/mainMenuOperations/localEntityListInMenuItem';
const controlledActions = {
    create: [819],
    fetch: [820],
    update: [821],
    delete: [822],
    downloadList: [820],
    uploadList: [-1]
};
const columns = () => {
    return [
        // @ts-ignore
        { name: 'row_menu', style: 'width:20px', hideWhenCreatingAndEditing, type: 'row_menu', menuItemShortcuts: ['del', 'copy'] },
        { name: 'id', style: 'width:50px', hideWhenCreatingAndEditing },
        { name: 'name', style: 'width:200px' },
        { name: 'applicable_to_table_ids', style: 'width:200px' },
        { name: 'created_by_user_id', style: 'width:200px' },
        { name: 'created_at', style: 'width:200px' },
        { name: 'updated_by_user_id', style: 'width:200px' },
        { name: 'updated_at', style: 'width:200px' },
        { name: 'generic_table_props_to_mix_in' },
        { name: 'all_users_can_use', isCheckbox: true },
        { name: 'disabled_at', style: 'width:200px' }
    ];
};
const remoteEntityName = 'meta.table_views';
const localEntityName = remoteEntityName;
const localEntity = constructLocalEntity({
    columns,
    remoteEntityName,
    apiVersion: 1,
    controlledActions,
    pageTitle: 'Table views'
});
export default localEntity;
export const meta__table_views__menuItem = () => (Object.assign({ label: '', icon: { name: 'mdi-keyboard-outline' }, prefetch: true }, localEntityListInMenuItem({
    localEntityNameProp: localEntityName
})));
